import React from 'react';
const ReviewParticipationsContext = React.createContext(null);
export const ReviewParticipationsProvider = ({ children, data }) => {
    const [selectedPositions, setSelectedPositions] = React.useState({});
    const [participations, setParticipations] = React.useState(data);
    const [showErrors, setShowErrors] = React.useState(false);
    const updateSelectedPositions = (rowId, positionId) => {
        setSelectedPositions((p) => (Object.assign(Object.assign({}, p), { [rowId]: positionId })));
    };
    const validateSelectedPositions = () => {
        const participationsWithMultiplePositions = participations.filter((participation) => participation.columns.positions.length > 1);
        const someParticipationsMissingPosition = participationsWithMultiplePositions.some((participation) => !selectedPositions[participation.id]);
        if (someParticipationsMissingPosition) {
            setShowErrors(true);
            return { valid: false };
        }
        return { valid: true };
    };
    const removeParticipation = (participationId) => {
        setParticipations((prevParticipations) => prevParticipations.filter(({ id }) => id !== participationId));
    };
    return (React.createElement(ReviewParticipationsContext.Provider, { value: {
            selectedPositions,
            updateSelectedPositions,
            showErrors,
            validateSelectedPositions,
            removeParticipation,
            participations,
        } }, children));
};
export const useReviewParticipationsContext = () => {
    const context = React.useContext(ReviewParticipationsContext);
    if (!context) {
        throw Error('Review Dialog Context must be used inside ReviewParticipationsProvider');
    }
    return context;
};
